import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-form-package/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Form, Field } from '../src';
import { Playground } from 'docz';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "onfocus-onchange-onblur"
    }}>{`onFocus, onChange, onBlur`}</h1>
    <blockquote>
      <p parentName="blockquote">{`get access to the state everytime the user interacts with your form`}</p>
    </blockquote>
    <p>{`Sometimes, access to the forms state is needed even before the user submits the form. This can be if you want to store the forms state on the server on every change (e.g. every time the user changes a input or everytime the user blurs an input) or you want to check if the users input is already taken (e.g. a user might not be allowed to use a email or a username that is already taken and you want to give the user a fast respond before the user even submits the form).`}</p>
    <p>{`You are not able to modify the state on this callbacks since `}<inlineCode parentName="p">{`react-form-package`}</inlineCode>{` takes care of the state management, but you can use the state to communicate with a server or change the UI corresponding to the current state. If you have an edge case where you have to modify the state of the input use `}<inlineCode parentName="p">{`preOnChange`}</inlineCode>{` (see `}<a parentName="p" {...{
        "href": "/react-form-package/state-manipulation"
      }}>{`State Manipulation`}</a>{`).`}</p>
    <h2 {...{
      "id": "onfocus"
    }}>{`onFocus`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {
  Form,
  Field,
} from 'react-form-package';
`}</code></pre>
    <p>{`Render a `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` with an email `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` component and a `}<inlineCode parentName="p">{`onFocus`}</inlineCode>{` property.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Take a look at the console.`}</p>
    </blockquote>
    <Playground __position={0} __code={'<Form>\n  {/* do something with the state onFocus */}\n  <Field\n    id=\"email\"\n    type=\"email\"\n    value=\"test@example.com\"\n    onFocus={state => console.log(state)}\n  />\n</Form>'} __scope={{
      props,
      DefaultLayout,
      Form,
      Field,
      Playground
    }} mdxType="Playground">
  <Form mdxType="Form">
    {
          /* do something with the state onFocus */
        }
    <Field id="email" type="email" value="test@example.com" onFocus={state => console.log(state)} mdxType="Field" />
  </Form>
    </Playground>
    <h2 {...{
      "id": "onchange"
    }}>{`onChange`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {
  Form,
  Field,
} from 'react-form-package';
`}</code></pre>
    <p>{`Render a `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` with an email `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` component and a `}<inlineCode parentName="p">{`onChange`}</inlineCode>{` property.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Take a look at the console.`}</p>
    </blockquote>
    <Playground __position={1} __code={'<Form>\n  {/* do something with the state onChange */}\n  <Field\n    id=\"email\"\n    type=\"email\"\n    value=\"test@example.com\"\n    onChange={state => console.log(state)}\n  />\n</Form>'} __scope={{
      props,
      DefaultLayout,
      Form,
      Field,
      Playground
    }} mdxType="Playground">
  <Form mdxType="Form">
    {
          /* do something with the state onChange */
        }
    <Field id="email" type="email" value="test@example.com" onChange={state => console.log(state)} mdxType="Field" />
  </Form>
    </Playground>
    <h2 {...{
      "id": "onblur"
    }}>{`onBlur`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {
  Form,
  Field,
} from 'react-form-package';
`}</code></pre>
    <p>{`Render a `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` with an email `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` component and a `}<inlineCode parentName="p">{`onBlur`}</inlineCode>{` property.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Take a look at the console.`}</p>
    </blockquote>
    <Playground __position={2} __code={'<Form>\n  {/* do something with the state onBlur */}\n  <Field\n    id=\"email\"\n    type=\"email\"\n    value=\"test@example.com\"\n    onBlur={state => console.log(state)}\n  />\n</Form>'} __scope={{
      props,
      DefaultLayout,
      Form,
      Field,
      Playground
    }} mdxType="Playground">
  <Form mdxType="Form">
    {
          /* do something with the state onBlur */
        }
    <Field id="email" type="email" value="test@example.com" onBlur={state => console.log(state)} mdxType="Field" />
  </Form>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      